import * as types from "../mutation-types";

const state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: true
  },
  effect: {
    translate3d: true
  },
  publicLayout: {
    status: false
  },
  isUseStoreOnline: false,
  // currency: "SGD",
  tag: "",
  timezone: null,
  currency: null,
  me: {}
};

const mutations = {
  [types.TOGGLE_DEVICE](state, device) {
    state.device.isMobile = device === "mobile";
    state.device.isTablet = device === "tablet";
  },

  [types.TOGGLE_SIDEBAR](state, opened) {
    state.sidebar.opened = opened;
    // console.log("opened :>> ", opened);
    // if (state.device.isMobile) {
    //   state.sidebar.opened = opened;
    // } else {

    // }
  },

  [types.SWITCH_EFFECT](state, effectItem) {
    for (let name in effectItem) {
      state.effect[name] = effectItem[name];
    }
  },

  [types.PUBLIC_LAYOUT](state, config) {
    if (config.hasOwnProperty("status")) {
      state.publicLayout.status = config.status;
    } else state.publicLayout.status = false;
  },

  [types.PERMISSION](state, permissions) {
    state.permissions = permissions;
  },

  [types.PROFILE](state, profile) {
    state.me = profile;
  },

  [types.TAG](state, tag) {
    state.tag = tag;
  },

  [types.TIMEZONE](state, timezone) {
    state.timezone = timezone;
  },

  [types.CURRENCY](state, currency) {
    state.currency = currency;
  },
  [types.SETTING](state, setting) {
    state.setting = setting;
  }
};

export default {
  state,
  mutations
};
